import {AssetTypeModel, DtoAssetTypeRequestInterface, DtoAssetTypeResponseInterface} from "../interfaces";
import {mapAssetTypeTranslationFromDtoArray, mapAssetTypeTranslationToDtoArray} from "./asset-type-translation.mapping";
import {mapMediaInfoFromDtoArray} from "./media-info.mappings";
import {mapTechnologyFromDto} from "./technology.mapping";

export const mapAssetTypeFromDto = (dto: DtoAssetTypeResponseInterface): AssetTypeModel => {
  const assetCount = dto.assetCount ?? 0;
  const isCustomAssetType = dto.isCustomAssetType ?? false;

  return {
    businessUnit: dto.businessUnit,
    technologyId: dto.technologyId ?? dto.technology?.id,
    assetProductCategory: dto.assetProductCategory,
    developmentCode: dto.developmentCode,
    defaultAssetName: dto.defaultAssetName,
    translations: mapAssetTypeTranslationFromDtoArray(dto.translations ?? []),
    responsibleCompany: dto.responsibleCompany,
    lockStatus: dto.lockStatus,
    comment: dto.comment,
    punchConfigType: dto.punchConfigType,
    assetType: dto.assetType ?? "",
    isCustomAssetType: isCustomAssetType,
    technologyName: dto.technologyName ?? dto.technology?.name,
    technologyBusinessArea: dto.technologyBusinessArea ?? dto.technology?.businessArea,
    technology: dto.technology ? mapTechnologyFromDto(dto.technology) : undefined,
    imageFiles: mapMediaInfoFromDtoArray(dto.imageFiles ?? []),
    imageAvailable: mapMediaInfoFromDtoArray(dto.imageFiles ?? []).length > 0,
    materialnoCount: dto.materialnoCount ?? 0,
    assetCount: assetCount,
    mainAssetCount: dto.mainAssetCount ?? 0,
    subAssetCount: dto.subAssetCount ?? 0,
    changedBy: dto.changedBy,
    changedTimestamp: dto.changedTimestamp,
    canNotBeDeleted: !isCustomAssetType || assetCount > 0
  };
};

export const mapAssetTypeFromDtoArray = (array: Array<DtoAssetTypeResponseInterface>): Array<AssetTypeModel> => {
  const result: Array<AssetTypeModel> = [];

  array.forEach(dto => {
    result.push(mapAssetTypeFromDto(dto));
  });

  return result;
};

export const mapAssetTypeToDto = (model: AssetTypeModel): DtoAssetTypeRequestInterface => {
  return {
    businessUnit: model.businessUnit,
    technologyId: model.technologyId ?? model.technology?.id ?? null,
    assetProductCategory: model.assetProductCategory,
    developmentCode: model.developmentCode,
    defaultAssetName: model.defaultAssetName,
    translations: mapAssetTypeTranslationToDtoArray(model.translations ?? []),
    responsibleCompany: model.responsibleCompany ?? null,
    lockStatus: model.lockStatus,
    comment: model.comment,
    punchConfigType: model.punchConfigType
  };
};
